import { render, staticRenderFns } from "./setFontDialog.vue?vue&type=template&id=078a72b4&"
import script from "./setFontDialog.vue?vue&type=script&lang=js&"
export * from "./setFontDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports